var _class, _descriptor;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Helper from '@ember/component/helper';
import { inject as service } from '@ember/service';
const SORTED_DAYS = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];
const DAYS_TO_SHORT_MAP = {
  MON: 'Mon',
  TUE: 'Tue',
  WED: 'Wed',
  THU: 'Thu',
  FRI: 'Fri',
  SAT: 'Sat',
  SUN: 'Sun'
};
let FormatDayHourPeriods = (_class = class FormatDayHourPeriods extends Helper {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
  }
  /**
   * Formats the provided periods: FormatDayPeriod[] into a single string per each unique day / time combination.
   *
   * Example; we have five periods where MON, TUE, WED and THUR share the same time of 9AM to 5AM and FRI
   * has a different time of 10AM to 5PM.
   * [
   *   {
   *     dayOfWeek: "MON",
   *     startTime: "09:00:00",
   *     endTime: "17:00:00",
   *   },
   *   {
   *     dayOfWeek: "TUE",
   *     startTime: "09:00:00",
   *     endTime: "17:00:00",
   *   },
   *   {
   *     dayOfWeek: "WED",
   *     startTime: "09:00:00",
   *     endTime: "17:00:00",
   *   },
   *   {
   *     dayOfWeek: "THUR",
   *     startTime: "09:00:00",
   *     endTime: "17:00:00",
   *   }
   *   {
   *     dayOfWeek: "FRI",
   *     startTime: "10:00:00",
   *     endTime: "17:00:00",
   *   }
   * ]
   *
   * This will result in the following; Mon-Thu: 9AM-5PM • Fri: 10AM-5PM • Sat, Sun: Closed
   * When consecutive days are found as in the case of Mon - Thu the days between are not shown
   */
  compute([periods]) {
    if (!periods || periods.length === 0) {
      return '';
    }
    const groupedPeriods = this.groupPeriodsByStartAndEndTime(periods);
    const formattedPeriods = [];
    for (const [key, days] of Object.entries(groupedPeriods)) {
      const [startTime, endTime] = key.split('-');
      const formatted = `${this.formatDays(days)}: ${this.formatTime(startTime)}-${this.formatTime(endTime)}`;
      formattedPeriods.push(formatted);
    }
    const formattedClosedDays = this.getClosedPeriodDaysFormatted(periods);
    if (formattedClosedDays !== '') {
      formattedPeriods.push(formattedClosedDays);
    }
    return formattedPeriods.join('\u00A0\u00A0•\u00A0\u00A0');
  }

  /**
   * Provided a FormatDayPeriod[], groups into unique start / end times to combine days into a single array.
   * Example; If Mon, Tue and Wed are all open from 9AM to 5PM they will be grouped into a record
   * {
   *  "09:00:00-17:00:00": ["MON", "TUE", "WED"]
   * }
   */
  groupPeriodsByStartAndEndTime(periods) {
    const periodsGroupedByStartAndEndTime = {};
    for (const period of periods) {
      const startEndKey = `${period.startTime}-${period.endTime}`;
      if (!periodsGroupedByStartAndEndTime[startEndKey]) {
        periodsGroupedByStartAndEndTime[startEndKey] = [];
      }
      periodsGroupedByStartAndEndTime[startEndKey].push(period.dayOfWeek);
    }
    return periodsGroupedByStartAndEndTime;
  }

  /**
   * Formats an unsorted Day[] to a capitalized day string, if consecutive days
   * exist they will be combined to the start and end shortened day.
   *
   * Example: ["FRI", "MON", "TUE", "WED"]
   * Returns: "Mon-Wed, Fri"
   */
  formatDays(days) {
    const sortedDays = days.sort((a, b) => {
      return SORTED_DAYS.indexOf(a) - SORTED_DAYS.indexOf(b);
    });
    let lastDayIndex = -1;
    const formattedDays = [];
    for (const day of sortedDays) {
      const currentIndex = SORTED_DAYS.indexOf(day);
      if (lastDayIndex === -1 || currentIndex !== lastDayIndex + 1) {
        formattedDays.push([day]);
      } else {
        formattedDays[formattedDays.length - 1].push(day);
      }
      lastDayIndex = currentIndex;
    }
    const formattedDaysToShortDays = formattedDays.map(r => r.map(d => DAYS_TO_SHORT_MAP[d]));
    return formattedDaysToShortDays.map(range => {
      if (range.length > 2) {
        return `${range[0]}-${range[range.length - 1]}`;
      }
      if (range.length === 2) {
        return `${range[0]}, ${range[1]}`;
      }
      return range[0];
    }).join(', ');
  }

  /**
   * Converts a 24 hour h:m:s string to a 12 hour formatted string with AM / PM suffixes.
   *
   * Examples:
   * - 00:30:00 -> 12:30AM
   * - 009:00:00 -> 9AM
   * - 17::00 -> 5PM
   */
  formatTime(time) {
    const [hour, minute] = time.split(':').map(Number);
    if (hour <= 12) {
      return `${hour === 0 ? '12' : hour}${minute === 0 ? '' : `:${minute}`}AM`;
    }
    return `${hour - 12}${minute === 0 ? '' : `:${minute}`}PM`;
  }

  /**
   * Looks at all days part of FormatDayPeriod[] to find any days that do not exist. The days are then
   * combined and formatted to a single string if any days are missing. This is appended onto the
   * result of the helper method
   */
  getClosedPeriodDaysFormatted(periods) {
    const closedMap = {
      MON: true,
      TUE: true,
      WED: true,
      THU: true,
      FRI: true,
      SAT: true,
      SUN: true
    };
    for (const p of periods) {
      if (closedMap[p.dayOfWeek]) {
        closedMap[p.dayOfWeek] = false;
      }
    }
    const days = [];
    for (const [key, closed] of Object.entries(closedMap)) {
      if (closed) {
        days.push(key);
      }
    }
    const formattedDays = this.formatDays(days);
    if (formattedDays.length === 0) {
      return '';
    }
    return `${formattedDays}: ${this.intl.t('sharedUi.common.closed')}`;
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
export { FormatDayHourPeriods as default };